import React, { FC, Fragment, useContext, useEffect, useState } from "react";
import StartRating from "components/StartRating/StartRating";
import Avatar from "shared/Avatar/Avatar";
import { useLocation, useNavigate } from "react-router-dom";
import { Dialog, Transition, Popover } from "@headlessui/react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import {
  Squares2X2Icon,
  HeartIcon,
  EyeIcon,
} from "@heroicons/react/24/outline";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import ButtonClose from "shared/ButtonClose/ButtonClose";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_URL } from "../../../src/api/config";
import axios from "axios";
import DetailPagetLayout from "./Layout";
import { AuthContext } from "context/userContext";
import SectionDateRange from "components/DatePickerComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faAirbnb } from "@fortawesome/free-brands-svg-icons";
import bedIcon from "../../images/beds.svg";
import roomIcon from "../../images/rooms.svg";
import bathIcon from "../../images/bath.svg";
import guestIcon from "../../images/guests.svg";
import sunrise from "../../images/sunrise.svg";
import mapMarker from "../../images/map-marker.svg";
import airport from "../../images/airport.svg";
import CardSkeleton from "./CardSkeleton";

const StayDetailPageContainer: FC<{}> = () => {
  const [propertyData, setPropertyData] = useState<any>({});
  const [bookings, setBookings] = useState<any>([]);
  const [amenitiesArray, setAmenitiesArray] = useState<
    { name: string; icon: string }[]
  >([]);
  const [propertyHighlightsArray, setPropertyHighlightsArray] = useState<
    { name: string; icon: string }[]
  >([]);
  const [totalOwnerProperty, setTotalOwnerProperty] = useState<number>(0);
  const [loading, setLoading] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [startDate, setStartDate] = useState<Date | null>(new Date());
  const [endDate, setEndDate] = useState<Date | null>(new Date());
  const [imageReloadKey, setImageReloadKey] = useState(Date.now());
      const [deletePopoverOpen, setDeletePopoverOpen] = useState(false);

  const { amenities, propertyHighlights } = propertyData;

  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const { fetchBookings, checkinDates, checkoutDates, bookedDates } =
    authContext;
  const queryParams = new URLSearchParams(window.location.search);
  const propIdParam = queryParams.get("propID");
  const token = localStorage.getItem("token");

  const getOnePropertyDetails = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${API_URL}/property/get-propertyCard-details?id=${propIdParam}`
      );
      if (response.data.error === false) {
        setPropertyData(response.data.propertyDetails);
        setTotalOwnerProperty(response.data.countTotalProperties);
        setLoading(false);
      } else {
        toast.error(response.data.message);
      }
    } catch (err) {
      toast.error("Error while fetching property details");
      console.error("Error fetching details", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (amenities && Array.isArray(amenities)) {
      const mappedAmenities = amenities.map((name: string) => ({
        name,
        icon: iconMap[name] || "", // Fallback to empty string if icon is not found
      }));
      setAmenitiesArray(mappedAmenities);
    } else {
      setAmenitiesArray([]); // Set an empty array if amenities is undefined
    }
    if (propertyHighlights && Array.isArray(propertyHighlights)) {
      const mappedPropertyHighlights = propertyHighlights.map(
        (name: string) => ({
          name,
          icon: highlightsIconMap[name],
        })
      );
      setPropertyHighlightsArray(mappedPropertyHighlights);
    } else {
      setPropertyHighlightsArray([]);
    }
  }, [propertyData]);

      useEffect(() => {
    if (propertyData?.ownerID?.image) {
      setImageReloadKey(Date.now());
    }
  }, [propertyData?.ownerID?.image]);

  useEffect(() => {
    getOnePropertyDetails();
  }, []);

  useEffect(() => {
    fetchBookings(propIdParam);
  }, [propIdParam, bookings]);

  // Function to apply different styles based on check-in and check-out
  // const getDayClassName = (date: Date) => {
    
  //   const dateString = date.toDateString();
  //   const today = new Date();
  //   today.setHours(0, 0, 0, 0); // Normalize today's date
  //   // Check if the date is a past check-in or check-out date
  //   const isPastCheckin = checkinDates.some(
  //     (d: any) => d.toDateString() === dateString && d < today
  //   );
  //   const isPastCheckout = checkoutDates.some(
  //     (d: any) => d.toDateString() === dateString && d < today
  //   );

  //   if (isPastCheckin) {
  //     return "past-booking-checkin"; // Apply past booking styling
  //   }
  //   if (isPastCheckout) {
  //     return "past-booking-checkout";
  //   }
  //   if (checkinDates.some((d: any) => d.toDateString() === dateString)) {
  //     return "checkin-date"; // Apply check-in styling
  //   }
  //   if (checkoutDates.some((d: any) => d.toDateString() === dateString)) {
  //     return "checkout-date"; // Apply check-out styling
  //   }
  //   if (bookedDates.some((d: any) => d.toDateString() === dateString)) {
  //     return "booking-range"; // Apply in-between styling
  //   }

  //   return ""; // No style if not booked
  // };

  const getDayClassName = (date: Date) => {
    const dateString = date.toDateString();
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Normalize today's date
    // Check if the date is a past check-in or check-out date
    const isPastCheckin = checkinDates.some(
      (d: any) => d.toDateString() === dateString && d < today
    );
    const isPastCheckout = checkoutDates.some(
      (d: any) => d.toDateString() === dateString && d < today
    );
  
    let classNames = "";
  
    if (isPastCheckin) {
      classNames += " past-booking-checkin";
    }
    if (isPastCheckout) {
      classNames += " past-booking-checkout";
    }
    const isCheckinDate = checkinDates.some((d: any) => d.toDateString() === dateString);
    const isCheckoutDate = checkoutDates.some((d: any) => d.toDateString() === dateString);
    
    // Check if both checkin and checkout are on the same day
    if (isCheckinDate && isCheckoutDate) {
      classNames += " checkin-checkout-same-day";
    } else {
      if (isCheckinDate) {
        classNames += " checkin-date";
      }
      if (isCheckoutDate) {
        classNames += " checkout-date";
      }
    }
    // const isDayBeforeCheckout = checkoutDates.some((d: any) => {
    //   const co = new Date(d);
    //   co.setHours(0, 0, 0, 0);
    //   const prev = new Date(co);
    //   prev.setDate(prev.getDate() - 1);
    //   return prev.toDateString() === dateString;
    // });
    // if (isDayBeforeCheckout) {
    //   classNames += " checkout-date";
    // }
    if (bookedDates.some((d: any) => d.toDateString() === dateString)) {
      //do not apply booking-range class if its a check-in or check-out date
      if (!checkoutDates.some((d: any) => d.toDateString() === dateString) && !checkinDates.some((d: any) => d.toDateString() === dateString)) {
        classNames += " booking-range";
      }
    }
  
    // Disable check-in date from being reselected as check-out
    // if (startDate && date.getTime() === startDate.getTime()) {
    //   classNames += " pointer-events-none";
    // }

    return classNames.trim(); // Trim spaces for clean class output
  };
  

  // Function to check if a date is already booked
  const isDateDisabled = (date: string) => {
    return bookedDates.some(
      (d: any) => new Date(d).toISOString().split("T")[0] === date
    );
  };

  const handleEditProperty = () => {
    navigate(`/edit-property/${propIdParam}`);
  };

    const confirmDeleteProperty = async () => {
        setDeletePopoverOpen(false);
        try {
          const response = await axios.post(`${API_URL}/property/delete-property`,{propId: propIdParam}, {
            headers: {
              token: token,
            },
          });
          if (response.data.error === false) {
            toast.success(`${response.data.message}`);
            navigate(`/properties`);
          }
        } catch (error) {
          toast.error("Failed to delete property.");
        }
      };

  const {
    type,
    title,
    bedrooms,
    beds,
    bathrooms,
    place_descriptions,
    cover_image,
    galleryImgs,
    count,
    avgRating,
    price,
    category,
    viewsCount,
    Address,
    guests,
    city,
  } = propertyData;

  const PHOTOS: string[] = [];
  if (cover_image) {
    PHOTOS.push(cover_image);
  }
  if (galleryImgs) {
    PHOTOS.push(...galleryImgs);
  }

  let [isOpenModalAmenities, setIsOpenModalAmenities] = useState(false);

  const thisPathname = useLocation().pathname;
  const router = useNavigate();

  function closeModalAmenities() {
    setIsOpenModalAmenities(false);
  }

  function openModalAmenities() {
    setIsOpenModalAmenities(true);
  }

  const handleOpenModalImageGallery = (e: any) => {
    router(`${thisPathname}?modal=PHOTO_TOUR_SCROLLABLE&propID=${propIdParam}`);
    e.stopPropagation();
  };

  // RENDER FORMATTED ADDRESS
  const addressArray =
    typeof Address === "string" && Address.trim()
      ? Address.split(",")
          .map((item: any) =>
            item
              .trim()
              .replace(/\b\d{6}\b/, "")
              .trim()
          ) // Remove pincode if part of the string
          .filter((part: any) => part) // Remove empty strings
      : [];
      

  // Icon mapping
  const iconMap: { [key: string]: string } = {
    "Self Checkin": "/Amenities/fingerprint.svg",
    "Toiletries": "/Amenities/Shampoo.svg",
    Towels: "/Amenities/towel2.svg",
    "Mosquito repellent": "/Amenities/mosquitoRepellent.svg",
    "Room Freshner": "/Amenities/snowflake.svg",
    Induction: "/Amenities/cooking.svg",
    Wifi: "/Amenities/wifi.svg",
    "Gas Stove": "/Amenities/gasstove.svg",
    "Smart TV": "/Amenities/monitor.svg",
    Blankets: "/Amenities/Towel.svg",
    Bedsheets: "/Amenities/doublebed.svg",
    Utensils: "/Amenities/utensils.svg",
    Iron: "/Amenities/iron.svg",
    "24/7 Water Supply": "/Amenities/raindrops.svg",
    "HouseKeeping Service": "/Amenities/Butler.svg",
    "Clothes Hanger": "/Amenities/hanger.svg",
    Showers: "/Amenities/Shower.svg",
    Wardrobe: "/Amenities/wardrobe.svg",
    "Jet Spray": "/Amenities/jetspray.svg",
    "Laundry Service": "/Amenities/laundry.svg",
    Balcony: "/Amenities/Hall.svg",
    Oven: "/Amenities/Kitchen.svg",
    "Washing Machine": "/Amenities/washingMachine.svg",
    "Scenic Views": "/Amenities/scenicviews.svg",
    Fridge: "/Amenities/fridge.svg",
    "Water Filter": "/Amenities/waterpurifier.svg",
    Microwave: "/Amenities/microwave.svg",
    "Mineral Water": "/Amenities/mineralwater.svg",
    "Water Heater": "/Amenities/waterheater.svg",
    "Water Storage Tank": "/Amenities/watertank.svg",
    "EV Charging": "/Amenities/ev charging.svg",
    "Car Parking": "/Amenities/car.svg",
  };

  const highlightsIconMap: { [key: string]: string } = {
    "Couple Friendly": "/PropHighlights/couple.svg",
    "Pet Friendly": "/PropHighlights/pet.svg",
    "Smoking Allowed": "/PropHighlights/cigeratte.svg",
    "Party Friendly": "/PropHighlights/glasscheers.svg",
    "Shoot Friendly": "/PropHighlights/camera.svg",
  };
const getLandmarkSentence = (label: string | null | undefined): string => {
  if (!label) {
    return "The property is located at a beautiful location.";
  }

  switch (label.toLowerCase()) {
    case "on the beach": return "The property is located on the beach."; 
    case "in the hills": return "The property is located in the hills."; 
    case "downtown": return "The property is located downtown."; 
    case "inside a forest": return "The property is located inside a forest."; 
    case "riverside": return "The property is located by the riverside."; 
    case "urban area": return "The property is located in an urban area."; 
    case "rural area": return "The property is located in a rural area."; 
    case "near wildlife": return "The property is located near wildlife."; 
    case "on the lake": return "The property is located on the lake."; 
    default: return "The property is located at a beautiful location.";
  }
}
  const renderPropertyInfo = () => {
          const getAvatarImageUrl = (url: string | undefined) => {
    if (!url) {
      return "";
    }
    // Only apply cache busting if it's a URL and not a Base64 string
    if (url.startsWith("data:image")) {
      return url;
    }
    return `${url}?${imageReloadKey}`;
  };
    return (
      <>
        {loading ? (
          <CardSkeleton />
        ) : (
          <div className="listingSection__wrap !space-y-6">
            {propertyData && (
              <div className="flex justify-between items-center">
                <h2 className="text-2xl sm:text-3xl lg:text-4xl lg:font-semibold font-[500] capitalize">
                  {title}
                </h2>
              </div>
            )}

            <div className="flex items-center text-neutral-6000 dark:text-neutral-300 text-sm lg:text-sm ">
              {!!count && <StartRating reviewCount={count} point={avgRating} />}

              <span>{category}</span>
              <span style={{ margin: "0 5px", fontWeight: "bold" }}>•</span>
              <span className="">{type}</span>
              <span style={{ margin: "0 5px", fontWeight: "bold" }}>•</span>

              {/* <span>{addressArray?.slice(-2).join(" , ").split('-')[0]}</span> */}
              <span>{city && city.split('-')[0]}</span>

            </div>

            <div className="flex items-center">
              <Avatar
                sizeClass="lg:h-10 lg:w-10 h-8 w-8"
                radius="rounded-full"
                ownerFirstName={propertyData?.ownerID?.firstname || ""}
                ownerLastName={propertyData?.ownerID?.lastname}
                imgUrl={getAvatarImageUrl(propertyData?.ownerID?.image)}
              />

              <span className="ml-2.5 text-neutral-500 dark:text-neutral-400 text-xs lg:text-[14px]">
                Hosted by{" "}
                <span className="capitalize text-neutral-900 dark:text-neutral-200 font-medium text-xs lg:text-[14px]">
                  {propertyData?.ownerID?.firstname}
                </span>
              </span>
            </div>

            <div className="flex items-center text-xs lg:text-sm text-neutral-700 dark:text-neutral-300">
              <div className="flex items-center">
                <HeartIcon className="lg:w-5 lg:h-5 w-3 h-3" />&nbsp;
                <span>{propertyData?.likesCount || 0}</span>
              </div>
              <span style={{ margin: "0 5px", fontWeight: "bold" }}>•</span>

              <div className="flex items-center">
                <EyeIcon className="lg:w-5 lg:h-5 w-3 h-3" />&nbsp;
                <span>{viewsCount || 0}</span>
              </div>
            </div>
            <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg border border-gray-200">
              <div>
                <h3 className="text-lg font-semibold text-gray-800">
                  Popular Listing
                </h3>
                <p className="text-sm text-neutral-500">{`${viewsCount} overall views`}</p>
              </div>
              {propertyData.airbnb_link ? (
                <>
                  <a
                    href={propertyData?.airbnb_link}
                    target="_blank"
                    rel="noreferrer"
                    className="flex items-center gap-2 text-white text-sm font-medium px-4 py-2 rounded-full shadow-m"
                    style={{ backgroundColor: "#FF395D" }}
                  >
                    <FontAwesomeIcon
                      icon={faAirbnb as IconProp}
                      className="text-sm text-white	"
                    />
                    View on Airbnb
                  </a>
                </>
              ) : (
                ""
              )}
            </div>

            <div className="w-full border-b border-neutral-100 dark:border-neutral-700" />

            <div className="flex justify-between items-center text-neutral-700 dark:text-neutral-300">
              <figure>
                <img src={guestIcon} className="m-auto" alt="guests" />
                <figcaption className="text-xs lg:text-sm mt-2">
                  {guests} Guests
                </figcaption>
              </figure>
              <figure>
                <img src={roomIcon} className="m-auto" alt="bedrooms" />
                <figcaption className="text-xs lg:text-sm mt-2">
                  {bedrooms} Bedrooms
                </figcaption>
              </figure>
              <figure>
                <img src={bedIcon} className="m-auto" alt="beds" />
                <figcaption className="text-xs lg:text-sm mt-2">
                  {beds} Beds
                </figcaption>
              </figure>
              <figure>
                <img src={bathIcon} className="m-auto" alt="bath" />
                <figcaption className="text-xs lg:text-sm mt-2">
                  {bathrooms} Baths
                </figcaption>
              </figure>
            </div>
          </div>
        )}
      </>
    );
  };

  const renderStayNearby = () => {
    return (
      <div className="listingSection__wrap">
        <h2 className="text-2xl lg:font-semibold font-[500]">What's nearby?</h2>
        <div className="flex flex-col">
          <div className="flex flex-col">
            {propertyData?.landmark ? (
              <div className="listItem1 mb-4">
                <span className="flex">
                  <img
                    src={mapMarker}
                    alt="map"
                    className="border p-3.5 rounded-2xl"
                  />
                  <div className="flex flex-col ml-4">
                    <p className="text-sm lg:text-base font-medium first:text-neutral-700">
                      Landmark
                    </p>
                    <p className="capitalize text-neutral-6000 text-xs lg:text-sm">
                      {propertyData.landmark}
                    </p>
                  </div>
                </span>
              </div>
            ) : (
              ""
            )}

            {propertyData?.nearest_airport ? (
              <div className="listItem2 mb-4 ">
                <span className="flex">
                  <img
                    src={airport}
                    alt="map"
                    className="border p-3.5 rounded-2xl"
                  />
                  <div className="flex flex-col ml-4">
                    <p className="text-sm lg:text-base font-medium first:text-neutral-700">
                      Airport
                    </p>
                    <p className="text-neutral-6000 text-xs lg:text-sm">
                      {propertyData?.nearest_airport}
                    </p>
                  </div>
                </span>
              </div>
            ) : (
              ""
            )}
          </div>

          <div className="listItem3 mb-4 border rounded-2xl p-5 bg-gray-50">
            {propertyData?.typeOfLocation &&
            <span className="flex">
              <img src={sunrise} alt="map" className="" />
              <p className="text-sm lg:text-base font-medium first:text-neutral-700 ml-3 ">
                {getLandmarkSentence(propertyData.typeOfLocation)}
              </p>
            </span>}
          </div>
        </div>
      </div>
    );
  };
  const renderStayInfo = () => {
    return (
      <div className="listingSection__wrap">
        {propertyData?.place_descriptions ? (
          <>
            <h2 className="text-2xl lg:font-semibold font-[500]">
              About the property
            </h2>
            <span className="capitalize text-neutral-6000 dark:text-neutral-300 text-sm lg:text-[14px]">
              {place_descriptions}
            </span>
          </>
        ) : (
          ""
        )}
      </div>
    );
  };

  const renderAmenities = () => {
    return (
      <div className="listingSection__wrap">
        {propertyData?.amenities ? (
          <>
            <div>
              <h2 className="text-2xl lg:font-semibold font-[500]">
                Amenities{" "}
              </h2>
            </div>
            {/* 6 */}
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6 text-sm text-neutral-700 dark:text-neutral-300 ">
              {Array.isArray(amenitiesArray) &&
              amenitiesArray &&
              amenitiesArray.length > 0 ? (
                amenitiesArray.slice(0, 12).map((item) => (
                  <div key={item.name} className="flex items-center space-x-3">
                    {item.icon && <img src={item.icon} alt={item.name} />}
                    <span className="text-xs lg:text-sm">{item.name}</span>
                  </div>
                ))
              ) : (
                <p>No amenities available</p>
              )}
            </div>
            <div className="w-14 border-b border-neutral-200"></div>
            {Array.isArray(amenitiesArray) && amenitiesArray.length > 12 && (
              <>
                <div>
                  <ButtonSecondary type="button" onClick={openModalAmenities}>
                    View more amenities
                  </ButtonSecondary>
                </div>
                {renderModalAmenities()}
              </>
            )}
          </>
        ) : (
          ""
        )}
      </div>
    );
  };

  const renderTypeOfLocation = () => {
    return (
      <div className="listingSection__wrap">
        {propertyData?.typeOfLocation ? (
          <>
            <div>
              <h2 className="text-2xl lg:font-semibold font-[500]">
                Type of location
              </h2>
            </div>
            <div className="grid grid-cols-1 xl:grid-cols-3 gap-6 text-sm text-neutral-700 dark:text-neutral-300 ">
              {propertyData.typeOfLocation && propertyData.typeOfLocation}
            </div>
          </>
        ) : (
          ""
        )}
      </div>
    );
  };

  const renderHighlights = () => {
    return (
      <div className="listingSection__wrap">
        {propertyData?.propertyHighlights ? (
          <>
            <div>
              <h2 className="text-2xl lg:font-semibold font-[500]">
                Highlights{" "}
              </h2>
            </div>
            <div className="grid grid-cols-1 xl:grid-cols-3 gap-6 text-sm text-neutral-700 dark:text-neutral-300 ">
              {Array.isArray(propertyHighlightsArray) &&
              propertyHighlightsArray &&
              propertyHighlightsArray.length > 0 ? (
                propertyHighlightsArray.slice(0, 12).map((item) => (
                  <div key={item.name} className="flex items-center space-x-3">
                    {item.icon && <img src={item.icon} alt={item.name} />}
                    <span className="text-xs lg:text-sm">{item.name}</span>
                  </div>
                ))
              ) : (
                <p>No amenities available</p>
              )}
            </div>
          </>
        ) : (
          ""
        )}
      </div>
    );
  };

  const renderModalAmenities = () => {
    return (
      <Transition appear show={isOpenModalAmenities} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-[99999] flex items-center justify-center bg-black bg-opacity-40 h-screen"
          onClose={closeModalAmenities}
        >
          <div className="px-4 text-center w-full">
            <div className="inline-block py-8 w-full max-w-4xl max-h-screen overflow-y-auto">
              <div className="inline-flex pb-2 flex-col w-full text-left align-middle transition-all transform overflow-hidden rounded-2xl bg-white dark:bg-neutral-900 dark:border dark:border-neutral-700 dark:text-neutral-100 shadow-xl h-full">
                <div className="relative flex-shrink-0 px-6 py-4 border-b border-neutral-200 dark:border-neutral-800 text-center">
                  <h3
                    className="text-lg font-medium leading-6 text-gray-900"
                    id="headlessui-dialog-title-70"
                  >
                    Amenities
                  </h3>
                  <span className="absolute left-3 top-3">
                    <ButtonClose onClick={closeModalAmenities} />
                  </span>
                </div>
                <div className="px-8 overflow-auto text-neutral-700 dark:text-neutral-300 divide-y divide-neutral-200">
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                    {amenitiesArray
                      .filter((_, i) => i < 1212)
                      .map((item) => (
                        <div
                          key={item.name}
                          className="flex items-center py-2.5 sm:py-4 lg:py-5 space-x-5 lg:space-x-8"
                        >
                          <img src={item.icon} alt="icon" />
                          <span>{item.name}</span>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Dialog>
      </Transition>
    );
  };

  const renderAvailability = () => {
    const validationSchema = Yup.object().shape({
      guestName: Yup.string().required("Guest name is required"),
      guestPhone: Yup.string()
        .matches(/^[0-9]{10}$/, "Phone number must be 10 digits")
        .required("Phone number is required"),
      guestEmail: Yup.string()
        .email("Invalid email")
        .required("Email is required"),
      checkinDate: Yup.date().required("Check-in date is required"),
      checkoutDate: Yup.date()
        .required("Check-out date is required")
        .min(
          Yup.ref("checkinDate"),
          "Checkout date must be after check-in date"
        ),
      numOfGuest: Yup.number()
        .typeError("Number of guests must be a number")
        .integer("Number of guests must be a whole number")
        .positive("Number of guests must be greater than zero")
        .min(1, "At least 1 guest is required")
        .required("Number of guests is required"),
    });
    const handleSubmit = async (
      values: any,
      { resetForm }: { resetForm: () => void }
    ) => {
      resetForm();
      setIsPopoverOpen(false);
      try {
        const response = await axios.post(
          `${API_URL}/owner/book-property`,
          { ...values, propertyId: propIdParam },
          {
            headers: {
              token: token,
            },
          }
        );
        if (response.data.error === false) {
          setBookings(response.data.newBooking);
          toast.success(`${response.data.message}`);
        } else if (response.data.error === true) {
          toast.error(response.data.message);
        }
      } catch (error) {
        console.log("Error in booking property", error);
        toast.error("Failed to book property");
      }
    };

    const formatDate = (date: string | Date | null) => {
      if (!date) return "";
      const localDate = new Date(date);
      // Adjust to local timezone and extract YYYY-MM-DD format
      const year = localDate.getFullYear();
      const month = String(localDate.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
      const day = String(localDate.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };
    const formattedStartDate = formatDate(startDate);
    const formattedEndDate = formatDate(endDate);

    const onCancelSelection = () => {
      setStartDate(null);
      setEndDate(null);
      setIsPopoverOpen(false);
    };
    
    const today = new Date().toISOString().split("T")[0];
    const dateInput = document.getElementById("datePicker") as HTMLInputElement;

    if (dateInput) {
      dateInput.addEventListener("focus", function () {
        this.setAttribute(
          "onkeydown",
          "return false;" // Prevent manual input
        );
      });
    
      dateInput.addEventListener("input", function () {
        if (bookedDates.includes(this.value)) {
          alert("This date is already booked!");
          this.value = ""; // Reset input
        }
      });
    
  
    }
    const initialValues = {
      guestName: "",
      guestEmail: "",
      guestPhone: "",
      checkinDate: formattedStartDate || "", // Ensure this remains set
      checkoutDate: formattedEndDate || "",
      numOfGuest: "",
    };
    return (
      <>
        <div className="flex items-center space-x-4 mb-2">
          <SectionDateRange
            getDayClassName={getDayClassName}
            price={price}
            setIsPopoverOpen={setIsPopoverOpen}
            startDate={startDate}
            endDate={endDate}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            bookings={bookings}
            bookedDates={bookedDates}
          />
          <Popover className="relative !z-max">
            {({ open }) => (
              <>
                <Transition
                  as={Fragment}
                  show={isPopoverOpen}
                  enter="transition ease-out duration-200"
                  enterFrom="opacity-0 translate-y-4"
                  enterTo="opacity-100 translate-y-0"
                  leave="transition ease-in duration-150"
                  leaveFrom="opacity-100 translate-y-0"
                  leaveTo="opacity-0 -translate-y-4"
                >
                  <Popover.Panel className="absolute left-1/2 transform -translate-x-[106%] -translate-y-1/3 mt-3 w-96 bg-white shadow-lg ring-1 ring-black ring-opacity-5 p-5 rounded-md">
                    <h4 className="text-lg font-semibold mb-2">
                      Add New Booking
                    </h4>
                    <Formik
                      initialValues={initialValues}
                      validationSchema={validationSchema}
                      onSubmit={handleSubmit}
                    >
                      {({ isSubmitting, values, setFieldValue }) => (
                        <Form>
                          <div className="mt-4">
                            <Field
                              type="text"
                              name="guestName"
                              placeholder="Guest Name"
                              className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-2 bg-white"
                              onChange={(e: any) => {
                                setFieldValue("guestName", e.target.value);
                              }}
                            />
                            <ErrorMessage
                              name="guestName"
                              component="div"
                              className="text-red-500 text-sm mt-1"
                            />
                          </div>
                          <div className="mt-4">
                            <Field
                              type="tel"
                              name="guestPhone"
                              placeholder="Guest Phone"
                              className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-2 bg-white"
                              onChange={(e: any) => {
                                setFieldValue("guestPhone", e.target.value);
                              }}
                            />
                            <ErrorMessage
                              name="guestPhone"
                              component="div"
                              className="text-red-500 text-sm mt-1"
                            />
                          </div>
                          <div className="mt-4">
                            <Field
                              type="email"
                              name="guestEmail"
                              placeholder="Guest Email"
                              className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-2 bg-white"
                              onChange={(e: any) => {
                                setFieldValue("guestEmail", e.target.value);
                              }}
                            />
                            <ErrorMessage
                              name="guestEmail"
                              component="div"
                              className="text-red-500 text-sm mt-1"
                            />
                          </div>
                          <div className="mt-4">
                            <Field
                              type="number"
                              name="numOfGuest"
                              placeholder="Number of guests"
                              className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-2 bg-white"
                              onChange={(e: any) => {
                                setFieldValue("numOfGuest", e.target.value);
                              }}
                            />
                            <ErrorMessage
                              name="numOfGuest"
                              component="div"
                              className="text-red-500 text-sm mt-1"
                            />
                          </div>
                          <div className="mt-4">
                            <Field
                              min={today}
                              type="date"
                              id="datePicker"
                              name="checkinDate"
                              onChange={(e: any) => {
                                const selectedDate = e.target.value;
                                if (isDateDisabled(selectedDate)) {
                                  toast.warn("This date is already booked!");
                                } else {
                                  setFieldValue("checkinDate", selectedDate);
                                }
                              }}
                              className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-2 bg-white"
                            />
                            <ErrorMessage
                              name="checkinDate"
                              component="div"
                              className="text-red-500 text-sm mt-1"
                            />
                          </div>
                          <div className="mt-4">
                            <Field
                              type="date"
                              name="checkoutDate"
                              onChange={(e: any) => {
                                const selectedDate = e.target.value;
                                if (isDateDisabled(selectedDate)) {
                                  toast.warn("This date is already booked!");
                                } else {
                                  setFieldValue("checkoutDate", selectedDate);
                                }
                              }}
                              className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-2 bg-white"
                            />
                            <ErrorMessage
                              name="checkoutDate"
                              component="div"
                              className="text-red-500 text-sm mt-1"
                            />
                          </div>

                          <div className="mt-4 flex justify-end space-x-2">
                            <button
                              type="button"
                              onClick={() => onCancelSelection()}
                              className="px-4 py-2 bg-gray-300 rounded-md"
                            >
                              Cancel
                            </button>
                            <button
                              type="submit"
                              disabled={isSubmitting}
                              className="px-4 py-2 bg-custom-color text-white rounded-md"
                            >
                              Submit
                            </button>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </Popover.Panel>
                </Transition>
              </>
            )}
          </Popover>
        </div>

        <div className={`${isSticky ? "flex mt-2 " : "p-4 shadow-xl "}`}>
          <div className="lg:flex md:flex-row flex flex-col md:gap-x-5 justify-between gap-y-3 2xl:!mt-1 lg:!mt-1">
            <span
              className="lg:font-semibold lg:text-2xl font-[500] text-xl"
              style={{ fontFamily: "Roboto" }}
            >
              {Number(price).toLocaleString("en-IN", {
                style: "currency",
                currency: "INR",
                minimumFractionDigits: 0,
              })}
              <span className="block text-neutral-6000 dark:text-neutral-300  lg:text-sm font-[500] text-xs">
                /night
              </span>
            </span>
            <div>
              <button
                className="bg-custom-color text-white md:p-3 p-2 border rounded-full"
                onClick={() => handleEditProperty()}
              >
                Manage Property
              </button>
              <button
                className="bg-custom-color text-white md:p-3 p-2 border rounded-full ml-2"
                onClick={() => setDeletePopoverOpen(true)}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
        {/* DELETE ACCOUNT MODAL */}
                     <Transition show={deletePopoverOpen} as={Fragment}>
                        <Dialog
                          as="div"
                          className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50"
                          onClose={() => setDeletePopoverOpen(false)}
                        >
                          <Dialog.Panel className="bg-white dark:bg-gray-900 p-6 rounded-lg max-w-lg w-full shadow-xl">
                            <Dialog.Title className="text-lg font-semibold text-center">
                              Confirm Property Deletion
                            </Dialog.Title>
                            <p className="text-sm text-gray-600 dark:text-gray-400 text-center mt-2">
                              Are you sure you want to delete your property? This action cannot
                              be undone.
                            </p>
                            <div className="mt-4 flex justify-center gap-4">
                              <button
                                onClick={() => setDeletePopoverOpen(false)}
                                className="px-4 py-2 bg-gray-300 dark:bg-gray-700 rounded-md"
                              >
                                No, Cancel
                              </button>
                              <button
                                onClick={confirmDeleteProperty}
                                className="px-4 py-2 bg-red-600 text-white rounded-md"
                              >
                                Yes, Delete Property
                              </button>
                            </div>
                          </Dialog.Panel>
                        </Dialog>
                      </Transition>
      </>
    );
  };

  const renderPropertyRules = () => {
    const rules = propertyData?.propertyRules || [];

    // Check if propertyRules is empty or contains only an empty string
    if (rules.length === 0 || (rules.length === 1 && rules[0] === "")) {
      return null;
    }
    return (
      <div className="listingSection__wrap">
        {/* HEADING */}
        {propertyData?.propertyRules.length > 0 ? (
          <>
            <h2 className="text-2xl lg:font-semibold font-[500]">
              Property Rules
            </h2>

            {/* CONTENT */}
            <div className="mt-2">
              {propertyData?.propertyRules ? (
                <div className="mt-3">
                  {propertyData?.propertyRules.map((item: any, index: any) => (
                    <ul className="list-disc list-inside !mt-1 ml-3 text-neutral-700 text-sm">
                      <li className="text-xs lg:text-sm capitalize" key={index}>
                        {item}
                      </li>
                    </ul>
                  ))}
                </div>
              ) : (
                "No Rules Available"
              )}
            </div>
          </>
        ) : (
          ""
        )}
      </div>
    );
  };

  const renderCancellationPolicy = () => {
    return (
      <div className="listingSection__wrap">
        {/* HEADING */}
        <h2 className="text-2xl lg:font-semibold font-[500]">
          Cancellation policy
        </h2>

        {/* CONTENT */}

        <div className="mt-2">
          <p className="text-neutral-700 dark:text-neutral-300 text-sm lg:text-sm font-semibold mb-2">
            Please ensure you have thoroughly read and understood our cancellation policy before proceeding with your booking.
          </p>
          <p className="text-neutral-700 dark:text-neutral-300 text-sm lg:text-sm">
            By confirming your reservation, you acknowledge and agree to the terms outlined in the policy regarding refunds, rescheduling, and no-show conditions. This helps prevent any confusion or inconvenience at a later stage.
          </p>
        </div>
      </div>
    );
  };

  return (
    <div className="nc-ListingStayDetailPage lg:py-8 py-4">
      <>
        <>
          <header className="rounded-md sm:rounded-xl">
            <div
              className="relative grid grid-cols-3 sm:grid-cols-4 gap-1 sm:gap-2"
              style={
                PHOTOS.length === 1 ? { height: "530px", width: "100%" } : {}
              }
            >
              <div
                className="col-span-2 row-span-3 sm:row-span-2 relative rounded-md sm:rounded-xl overflow-hidden cursor-pointer"
                onClick={(e) => {
                  handleOpenModalImageGallery(e);
                }}
              >
                <img
                  className="absolute inset-0 object-cover rounded-md sm:rounded-xl w-full h-full"
                  src={PHOTOS[0]}
                  alt=""
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 50vw"
                />
                <div className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity"></div>
              </div>
              {PHOTOS.filter((_, i) => i >= 1 && i < 5).map((item, index) => (
                <div
                  key={index}
                  className={`relative rounded-md sm:rounded-xl overflow-hidden ${
                    index >= 3 ? "hidden sm:block" : ""
                  }`}
                >
                  <div className="aspect-w-4 aspect-h-3 sm:aspect-w-6 sm:aspect-h-5">
                    <img
                      className="absolute inset-0 object-cover rounded-md sm:rounded-xl w-full h-full"
                      src={item || ""}
                      alt=""
                      sizes="400px"
                    />
                  </div>

                  {/* OVERLAY */}
                  <div
                    className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity cursor-pointer"
                    onClick={handleOpenModalImageGallery}
                  />
                </div>
              ))}

              <button
                className="absolute hidden md:flex md:items-center md:justify-center left-3 bottom-3 px-4 py-2 rounded-xl bg-neutral-100 text-neutral-500 hover:bg-neutral-200 z-10"
                onClick={handleOpenModalImageGallery}
              >
                <Squares2X2Icon className="w-5 h-5" />
                <span className="ml-2 text-neutral-800 text-sm font-medium">
                  Show all photos
                </span>
              </button>
            </div>
          </header>
        </>
      </>

      {/* MAIN */}
      <main
        className={`${
          isSticky ? "z-10 mt-11 flex " : "z-10 mt-11 flex flex-col lg:flex-row"
        }`}
      >
        <div
          className={`${
            isSticky
              ? "xl:w-2/3 space-y-8 lg:space-y-10  lg:pr-10"
              : "lg:w-3/5 xl:w-2/3 space-y-8 lg:space-y-10 lg:pr-10"
          }`}
        >
          {renderPropertyInfo()}
          {renderStayNearby()}
          {renderStayInfo()}
          {renderAmenities()}
          {/* {renderTypeOfLocation()} */}
          {renderHighlights()}
          {renderPropertyRules()}
          {renderCancellationPolicy()}
        </div>

        {/* SIDEBAR */}

        <>
          {isSticky ? (
            <>
              <div className="lg:block mt-5 flex-grow lg:mt-0 h-max">
                <div className="">{renderAvailability()}</div>
              </div>
            </>
          ) : (
            <>
              <div className="lg:block flex-grow mt-5 lg:mt-0">
                <div className="sticky top-28">{renderAvailability()}</div>
              </div>
            </>
          )}
        </>
      </main>
    </div>
  );
};

export default function ListingStayDetailPage() {
  return (
    <DetailPagetLayout>
      <StayDetailPageContainer />
    </DetailPagetLayout>
  );
}
